<template>
  <div class="status-card bg-white dark:bg-bs-dark-bg-over cursor-pointer">
    <div class="pie-chart">
      <div class="base"></div>
      <svg  viewBox="0 0 66 66" class="pie-chart-arc">
        <g transform="translate(33,33)">
          <circle r="31" />
          <path :d="arcData" />
        </g>
      </svg>
      <p class="number ">{{ number }}</p>
    </div>
    <p class="title text-bs-gray-dark dark:text-white">{{ title }}</p>
    <div class="bar-chart">
      <div class="bar-line" 
          v-for="(d,index) in bars" 
          :key="index" 
          v-tooltip="tooltipString(d)"
          :style="`height:${d.value}%`"></div> 
    </div>
  </div>
</template>

<script>
import {arc} from 'd3'
import { format } from 'date-fns';
const radius=33.2;
const thickness = 4.4;

const arcFn = arc()
.innerRadius(radius - thickness)
.outerRadius(radius)
.cornerRadius(2)
export default {
  name: "StatusCard",
  props: {
    number: { type: Number, default: 0 },
    title: { type: String, default: "Wins" },
    arc: {type: Object, default: function(){
      return {}
    }},
    bars: {type: Array}
  },
  computed: { 
    arcData: function(){
      return arcFn(this.arc)
    }
  },
  methods: {
    tooltipString: function({value, day}){
      let val = value /100
      let d = format(new Date(day), 'do MMM')
      try {
        return `${val.toLocaleString('en-GB', {style:'percent'})} on ${d}`
      } catch (e){
        console.log(e, val)
        return `No tips on ${d}`
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/base.scss";
.status-card {
  border-radius: 25px;
  padding: 24px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @apply flex-grow
}
@screen lg {
  .status-card {
    padding: 24px 10px 20px 10px;
  }
}
.pie-chart {
  margin: 0 auto 20px;
  border-radius: 50%;
  position: relative;
  text-align:center;
  display: grid;
  grid-template-columns: 66px;
  grid-template-rows: 66px;
}

.wins .pie-chart  {
  box-shadow: 0 12px 12px 0 $transparent-forest-green;
  
}
.halfwins .pie-chart  {
  box-shadow: 0 12px 12px 0 $transparent-forest-green-light;
  
}
.voids .pie-chart  {
  box-shadow: 0 12px 12px 0 $transparent-orange;
  
}
.halflosses .pie-chart  {
  box-shadow: 0 12px 12px 0 $transparent-light-red;
  
}
.losses .pie-chart  {
  box-shadow: 0 12px 12px 0 $transparent-red-red;
  
}
.base {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  position: relative;
  grid-row: 1;
  grid-column:1;
  display:none;
  // border: 2px solid $forest-green;
}
.pie-chart svg {
  grid-row:1;
  grid-column:1;
  width: 72px;
  height: 72px;
  margin-top:-4px;
  margin-left:-4px;
}

.wins .pie-chart svg path {
  fill:$forest-green;
}
.halfwins .pie-chart svg path {
  fill: $forest-green-light;
}
.voids .pie-chart svg path {
  fill: $orange;
}
.halflosses .pie-chart svg path {
  fill: $light-red;
}
.losses .pie-chart svg path {
  fill: $red-red;
}
.pie-chart svg circle {
  fill:transparent;
  stroke-width: 4;
}
.wins .pie-chart svg circle {
  stroke:$forest-green-base;
  
}
.halfwins .pie-chart svg circle {
  stroke: $forest-green-base;
  
}
.voids .pie-chart svg circle {
  stroke: $orange-base;
  
}
.halflosses .pie-chart svg circle {
  stroke: $red-red-base;
  
}
.losses .pie-chart svg circle {
  stroke: $red-red-base;
  
}

.number {
  @include poppins-34-bold;
  text-align: center;
  grid-row: 1;
  grid-column:1;
  font-size: clamp(1rem, 24px, 34px);
  margin:auto;
}
.title {
  @include poppins-18-medium;
  text-align: center;
  white-space: nowrap;
  @apply mx-auto;
}

.wins .number  {
  color: $forest-green;
}
.halfwins .number  {
  color: $forest-green-light;
}
.voids .number  {
  color: $orange;
}
.halflosses .number  {
  color: $light-red;
}
.losses .number  {
  color: $red-red;
}



.bar-chart {
  min-width: 105px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 50px;
  width:100%;
  margin-top: 5px;
  @screen lg {
    min-width: 105px;
  }
  @screen xl {
    min-width: 90px;
  }
}
.bar-line {
  width: 4px;
  border-radius: 8px;
  background: linear-gradient(
    180deg,
    $forest-green 0%,
    $forest-green-base 100%
  );
}

.wins .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-forest-green;
  background: linear-gradient(180deg, $forest-green 0%, $forest-green-base 100%);
}
.dark .wins .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-forest-green;
  background: linear-gradient(180deg, $forest-green 0%, rgba(0,0,0,0) 100%);
}
.halfwins .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-forest-green-light;
  background: linear-gradient(180deg, $forest-green-light 0%, $forest-green-base 100%);
}
.dark .halfwins .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-forest-green-light;
  background: linear-gradient(180deg, $forest-green-light 0%,  rgba(0,0,0,0) 100%);
}
.voids .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-orange;
  background: linear-gradient(180deg, $orange 0%, $orange-base 100%);
}
.dark .voids .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-orange;
  background: linear-gradient(180deg, $orange 0%, rgba(0,0,0,0) 100%);
}
.halflosses .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-light-red;
  background: linear-gradient(180deg, $light-red 0%, $red-red-base 100%);
}
.losses .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-red-red;
  background: linear-gradient(180deg, $red-red 0%, $red-red-base 100%);
}
.dark .halflosses .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-light-red;
  background: linear-gradient(180deg, $light-red 0%, rgba(0,0,0,0) 100%);
}
.dark .losses .bar-line  {
  box-shadow: 0 8px 12px 0 $transparent-red-red;
  background: linear-gradient(180deg, $red-red 0%, rgba(0,0,0,0) 100%);
}


@screen 4xl {
  .number {
    font-size: clamp(1rem, 40px, 68px);
  }
  .pie-chart {
    grid-template-columns: 132px;
    grid-template-rows: 132px;
  }
  .base {
    width: 132px;
    height: 132px;
  }
  .pie-chart svg {
    width: 144px;
    height: 144px;
  }
  .bar-chart {
    height: 80px;
    max-width: 180px;
    margin: 1rem auto 0;
  }
  .bar-line {
    width: 6px;

  }
}

</style>